/**
 * 角色api
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();
export function getRolePermission(params) {
	/**查询角色权限 */
	return api.get(`/api/permission_role_v3`, params)
}

export function setRolePermissionV3(params) {
	/**设置角色权限 */
	return api.post(`/api/permission_role_v3`, params)
}

export function role_tree_v3() {
	/**角色权限tree  */
	return api.get(`/api/role_tree_v3`)
}

export function addRole(params) {
	/**添加角色 */
	return api.post('/api/role_v3', params)
}

export function deleteRoleV3(id) {
	/**删除角色 */
	return api.delete(`/api/role_v3/${id}`)
}

export function putRole(id, params) {
	/**修改角色 */
	return api.put(`/api/role_v3/${id}`, params)
}

export function getRoleById(id) {
	/**查询角色详情 */
	return api.get(`/api/role_v3/${id}`)
}

export function getRoleList(params) {
	/**查询角色列表 */
	return api.get(`/api/role_v3`, params)
}

export function getUserRoleList(params) {
	// 查询登录用户权限列表
	return api.get(`/api/role_select_v3`, params)
}

